"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StackedBarChart = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _victory = require("victory");

var _victory_theme = require("./victory_theme");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IEFriendlyVictoryChart = function IEFriendlyVictoryChart(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative',
      padding: 0,
      paddingBottom: "".concat(100 * (_victory_theme.baseProps.height / _victory_theme.baseProps.width), "%")
    }
  }, /*#__PURE__*/_react["default"].createElement(_victory.VictoryChart, _extends({}, props, {
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      parent: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      }
    })
  })));
};

var StackedBarChart = /*#__PURE__*/function (_Component) {
  _inherits(StackedBarChart, _Component);

  var _super = _createSuper(StackedBarChart);

  function StackedBarChart() {
    _classCallCheck(this, StackedBarChart);

    return _super.apply(this, arguments);
  }

  _createClass(StackedBarChart, [{
    key: "render",
    value: // eslint-disable-line react/prefer-stateless-function
    function render() {
      var _this = this;

      var total = 0;
      var label = '';
      var chartData = [];
      var chartDataCategories = [];
      var chartBars = [];
      var chartTickVals = [];
      var chartFormat = [];
      var tickVal = 1;
      var categoryColors = [];
      var xAxis;
      var _this$props = this.props,
          matrixAllocations = _this$props.matrixAllocations,
          categoriesSubtotals = _this$props.categoriesSubtotals,
          bracketNames = _this$props.bracketNames,
          isStatic = _this$props.isStatic; // Generates data set for chart

      matrixAllocations.forEach(function (category, categoryIndex) {
        bracketNames.forEach(function (bracketName, bracketIndex) {
          total = (0, _helpers.toFixed3NoTrailing0s)(categoriesSubtotals[categoryIndex][bracketIndex]);
          label = "".concat(total, "%");
          chartData.push({
            bracketName: bracketName,
            label: label,
            total: total
          });
        });
        chartDataCategories.push(chartData);
        chartData = []; // TODO: colors from api

        categoryColors.push(_this.props.categoryColors[categoryIndex]);
      });
      categoryColors.reverse(); // Generates tick values for chart

      bracketNames.forEach(function (bracketName) {
        chartTickVals.push(tickVal);
        chartFormat.push(bracketName);
        tickVal++;
      }); // Composes chart bars

      chartDataCategories.reverse().forEach(function (category, index) {
        chartBars.push( /*#__PURE__*/_react["default"].createElement(_victory.VictoryBar, {
          labelComponent: /*#__PURE__*/_react["default"].createElement(_victory.VictoryTooltip, {
            pointerLength: 5,
            cornerRadius: 2,
            flyoutStyle: {
              fill: '#3f3f3f'
            },
            style: {
              fill: '#fff',
              fontSize: '16px'
            }
          }),
          data: category,
          x: "bracketName",
          y: "total",
          key: index
        }));
      });

      if (isStatic) {
        xAxis = /*#__PURE__*/_react["default"].createElement(_victory.VictoryAxis, {
          tickValues: [0, 1, 2],
          tickFormat: chartFormat
        });
      } else {
        xAxis = /*#__PURE__*/_react["default"].createElement(_victory.VictoryAxis, {
          tickValues: chartTickVals,
          tickFormat: chartFormat,
          label: "Ages"
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true
      }, /*#__PURE__*/_react["default"].createElement(IEFriendlyVictoryChart, {
        theme: (0, _victory_theme.theme)(categoryColors, this.props.isStatic),
        domainPadding: 12
      }, /*#__PURE__*/_react["default"].createElement(_victory.VictoryAxis, {
        dependentAxis: true,
        tickValues: [25, 50, 75, 100],
        tickFormat: function tickFormat(tickVal) {
          return "".concat(tickVal, "%");
        }
      }), xAxis, /*#__PURE__*/_react["default"].createElement(_victory.VictoryStack, null, chartBars)));
    }
  }]);

  return StackedBarChart;
}(_react.Component);

exports.StackedBarChart = StackedBarChart;

_defineProperty(StackedBarChart, "propTypes", {
  matrixAllocations: _propTypes["default"].array.isRequired,
  bracketNames: _propTypes["default"].array.isRequired,
  isStatic: _propTypes["default"].bool.isRequired,
  categoriesSubtotals: _propTypes["default"].array.isRequired,
  categoryColors: _propTypes["default"].array.isRequired
});

var _default = StackedBarChart;
exports["default"] = _default;